// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"4487d8f0","294":"2096b966","620":"59581835","713":"519b7cb8","888":"c6b0dee1","976":"7e7f34be","977":"0d801a1a"}[chunkId] + ".chunk.js";
};